const today = new Date()
const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1)
const SubscribedActivities = [
    {
        id: 1,
        userSubscription: {
            id: 1,
            resourceSubscription: {
                articleId: 1,
                productId: null,
                commentId: null,
                discussionId: null,
                activityType: "Liked"
            },
            user: {
                id: 1,
                distributorId: null,
                authorId: 1,
                cognitoId: 1,
                firstName: "John",
                lastName: "Doe",
                email: "jdoe@gmail.com",
                role: "User",
                enabled: true,
                resendInvite: false
            }
        },
        activity: {
            id: 1,
            resourceSubscription: {
                articleId: 1,
                productId: null,
                commentId: null,
                discussionId: null,
                activityType: "Liked"
            },
            message: "Jane Doe liked AT Resources for Georgia"
        },
        created: yesterday,
        read: true
    },
    {
        id: 2,
        userSubscription: {
            id: 2,
            resourceSubscription: {
                articleId: null,
                productId: null,
                commentId: 1,
                discussionId: null,
                activityType: "Created"
            },
            user: {
                id: 1,
                distributorId: null,
                authorId: 1,
                cognitoId: 1,
                firstName: "John",
                lastName: "Doe",
                email: "jdoe@gmail.com",
                role: "User",
                enabled: true,
                resendInvite: false
            }
        },
        activity: {
            id: 2,
            resourceSubscription: {
                articleId: null,
                productId: null,
                commentId: 1,
                discussionId: null,
                activityType: "Created"
            },
            message: "Jane Doe commented on AT Resources for Georgia"
        },
        created: today.toISOString(),
        read: false
    }
]

export default SubscribedActivities
